import { Pipe, PipeTransform } from '@angular/core';
import { max } from 'rxjs/operators';

@Pipe({
    name: 'creditcard'
})
export class CreditCardPipe implements PipeTransform
{
    public transform(value: string, ...args: any[]): string
    {
        value = value.replace(/\s/g, '');
        const starCount = Math.max(0, 16 - value.length);
        const paddedValue = `${value}${Array.from((new Array(starCount)).keys()).map(x => '*').join('')}`;
        return `${paddedValue.slice(0, 4)} ${paddedValue.slice(4, 8)} ${paddedValue.slice(8, 12)} ${paddedValue.slice(12, 16)}`;
    }
}

